interface PlayerPlayProps {
  className?: string;
  size?: number;
  color?: string;
}

const PlayerPlay = ({ className, size = 12, color = "#F4FFF8" }: PlayerPlayProps) => {
  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    className={className}
    viewBox="0 0 12 12"
  >
    <path
      stroke={color}
      d="M3.5 2v8L10 6z"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
  );
};

export default PlayerPlay;
